<div class="ant-picker-panel-container">
  <div class="ant-picker-panels w-full">
    <div
      class="ant-picker-panel px-3 flex-1"
      *ngFor="let year of years; let index = index; let first = first; let last = last"
    >
      <div class="ant-picker-header">
        <button
          *ngIf="first"
          (click)="onChangeYears('prev')"
          type="button"
          class="ant-picker-header-super-prev-btn mr-3"
        >
          <span class="ant-picker-super-prev-icon"></span>
        </button>
        <div class="ant-picker-header-view">
          {{ year | date : "YYYY" }}
        </div>
        <button
          *ngIf="last"
          (click)="onChangeYears('next')"
          type="button"
          class="ant-picker-header-super-next-btn ml-3"
        >
          <span class="ant-picker-super-next-icon"></span>
        </button>
      </div>
      <div class="ant-picker-body">
        <div *ngFor="let quarter of listOfQuarter[index]" class="row h-[42px] leading-[42px]">
          <span
            (click)="onClickQuarter(quarter.value)"
            [class.bg-primary]="isSelected(quarter.value)"
            [class.text-white]="isSelected(quarter.value)"
            class="ant-picker-cell-in-view p-[5px] cursor-pointer"
            >{{ quarter.label | translate }}</span
          >
        </div>
      </div>
    </div>
  </div>

  <div class="ant-picker-footer px-3">
    <div *ngIf="extraFooter" class="ant-picer-footer-extra">
      <ng-container *ngTemplateOutlet="extraFooter"></ng-container>
    </div>
  </div>
</div>
